import { engine } from "../..";
import { getSuggestionsArgsParams } from "./getSuggestionsArgsParams";
import { BatchSuggestionArgsOptions } from "./initSuggestionArgs";

export function initRegulatingValvesSuggestionArgs({
  filters,
  ...valveSuggestionArgs
}: BatchSuggestionArgsOptions) {
  const { cleanup, params } = getSuggestionsArgsParams({
    filters,
    ...valveSuggestionArgs,
  });
  const args = new engine.BatchSelectionRegValvesArgs(...params);

  return {
    cleanup() {
      cleanup();
      args.delete();
    },
    suggestionArgs: args,
  };
}
